import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    id: String,
  }

  connect() {
    if (!this.idValue) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${this.idValue}`;

    // Forward the CSP nonce to GTM so it stamps the scripts it injects
    // (e.g. the CookieYes CMP tag), keeping them allowed under strict-dynamic.
    const nonce = document.querySelector('meta[name="csp-nonce"]')?.content;
    if (nonce) script.nonce = nonce;

    document.head.appendChild(script);
  }
}
